import React, { useEffect, useRef, useState } from 'react';
import numberSpaces from '../../../scripts/helpers/numbers.with.spaces';

function formatPrice( value ) {

  if ( value === null || value === undefined || value === '' ) { return ''; }
  if ( Number( value ) === 0 ) { return '0'; }

  return numberSpaces( value );

}

function pricesAreTied( price, pricePerJob ) {

  if ( price === null || price === undefined || price === '' ) { return false; }
  if ( pricePerJob === null || pricePerJob === undefined || pricePerJob === '' ) { return false; }

  const left = Number( price );
  const right = Number( pricePerJob );

  return Number.isFinite( left ) && left === right;

}

function sameNumbers( left, right ) {

  return Number( left ) === Number( right );

}

const PriceRow = ({ text, unit, price: savedPrice, pricePerJob: savedPricePerJob, onSave }) => {

  const inputRef = useRef( null );
  const jobInputRef = useRef( null );
  const savingRef = useRef( false );
  const skipSaveRef = useRef( false );
  const mountedRef = useRef( true );

  const initialJob = ( savedPricePerJob !== null && savedPricePerJob !== undefined && savedPricePerJob !== '' )
    ? savedPricePerJob
    : 0;

  const [ price, setPrice ] = useState( savedPrice );
  const [ pricePerJob, setPricePerJob ] = useState( initialJob );
  const [ showPriceInput, setShowPriceInput ] = useState( false );
  const [ showJobInput, setShowJobInput ] = useState( false );
  const [ rowError, setRowError ] = useState( '' );

  const tied = pricesAreTied( savedPrice, savedPricePerJob );
  const unitLabel = unit ? `р/${ unit }` : 'р';

  useEffect(() => () => { mountedRef.current = false; }, []);

  function focusSoon( ref ) {

    setTimeout(() => { ref.current && ref.current.focus(); }, 0 );

  }

  function beginEdit( setVisible, ref ) {

    skipSaveRef.current = false;
    setVisible( true );
    focusSoon( ref );

  }

  function closeInputs() {

    setShowPriceInput( false );
    setShowJobInput( false );

  }

  function restoreSaved() {

    setPrice( savedPrice );
    setPricePerJob( initialJob );

  }

  function valuesChanged() {

    return String( price ) !== String( savedPrice ) || String( pricePerJob ) !== String( initialJob );

  }

  function cancelEdit() {

    if ( valuesChanged() && !window.confirm( 'Отменить изменение цены?' ) ) { return; }

    skipSaveRef.current = true;
    restoreSaved();
    closeInputs();

  }

  async function savePrice() {

    if ( skipSaveRef.current ) {

      skipSaveRef.current = false;
      return;

    }

    if ( savingRef.current ) { return; }

    if ( sameNumbers( price, savedPrice ) && sameNumbers( pricePerJob, initialJob ) ) {

      closeInputs();
      setRowError( '' );
      return;

    }

    savingRef.current = true;
    closeInputs();

    try {

      const result = await onSave( price, pricePerJob );

      if ( !mountedRef.current ) { return; }

      if ( !result?.success ) {

        restoreSaved();
        setRowError( result?.text || 'Не удалось сохранить цену' );
        return;

      }

      setRowError( result?.text || '' );

    } catch ( err ) {

      if ( !mountedRef.current ) { return; }

      restoreSaved();
      setRowError( 'Не удалось сохранить цену' );

    } finally {

      savingRef.current = false;

    }

  }

  function changePrice( next ) {

    setPrice( next );
    if ( tied ) { setPricePerJob( next ); }

  }

  function changeJob( next ) {

    setPricePerJob( next );
    if ( tied ) { setPrice( next ); }

  }

  function onKeyDown( event ) {

    if ( event.key === 'Enter' ) {

      event.preventDefault();
      savePrice();

    } else if ( event.key === 'Escape' ) {

      event.preventDefault();
      cancelEdit();

    }

  }

  return (

    <div className = "company-prices__row">

      <div className = "company-prices__name">{ text }</div>

      <div className = "company-prices__field">

        <div className = "company-prices__label">За материалы</div>

        { showPriceInput

          ? <input

              ref = { inputRef }
              className = "company-prices__input"
              inputMode = "decimal"
              value = { price ?? '' }
              onChange = {( event ) => changePrice( event.target.value )}
              onBlur = { savePrice }
              onKeyDown = { onKeyDown }

            />

          : <button

              type = "button"
              className = "company-prices__value"
              onClick = {() => {

                if ( price === null ) { return; }

                beginEdit( setShowPriceInput, inputRef );

              }}

            >

              { formatPrice( price ) }
              <span className = "company-prices__unit">{ unitLabel }</span>

            </button>

        }

      </div>

      <div className = "company-prices__field">

        <div className = "company-prices__label">За работу</div>

        { showJobInput

          ? <input

              ref = { jobInputRef }
              className = "company-prices__input"
              inputMode = "decimal"
              value = { pricePerJob ?? '' }
              onChange = {( event ) => changeJob( event.target.value )}
              onBlur = { savePrice }
              onKeyDown = { onKeyDown }

            />

          : <button

              type = "button"
              className = "company-prices__value"
              onClick = {() => {

                beginEdit( setShowJobInput, jobInputRef );

              }}

            >

              { formatPrice( pricePerJob ) }
              <span className = "company-prices__unit">{ unitLabel }</span>

            </button>

        }

      </div>

      { rowError && <div className = "company-prices__error">{ rowError }</div> }

    </div>

  );

};

export default PriceRow;
